<template>
<div>
  <div
    id="list"
    class="w1100"
    v-loading.fullscreen.lock="fullscreenLoading"
    element-loading-text="处理中…… 请耐心等待"
    element-loading-spinner="el-icon-loading"
  >
    <div
     class="contentBox"
    >
      <div style="display: flex;width: 100%">
<!--        <div style="width: 220px; height: auto">-->
<!--          <div-->
<!--            style="-->
<!--              background-color: #0f5035;-->
<!--              color: #fff;-->
<!--              font-size: 20px;-->
<!--              height: 50px;-->
<!--              line-height: 50px;-->
<!--              text-align: center;-->
<!--              margin-bottom: 8px;-->
<!--            "-->
<!--          >-->
<!--            {{ firstMenuName }}-->
<!--          </div>-->
<!--          <div-->
<!--            :style="{-->
<!--              'border-left': item.id == menuId ? '4px solid #f9dc03' : '',-->
<!--              color: item.id == menuId ? '#115238' : '#666563',-->
<!--            }"-->
<!--            style="-->
<!--              height: 40px;-->
<!--              line-height: 40px;-->
<!--              background-color: #e9f8f2;-->
<!--              margin-bottom: 4px;-->
<!--              padding-left: 30px;-->
<!--              cursor: pointer;-->
<!--            "-->
<!--            v-for="(item, i) in menuList"-->
<!--            @click="changeList(item.id)"-->
<!--            :key="i"-->
<!--            :title="item.label"-->
<!--          >-->
<!--            {{ item.label }}-->
<!--          </div>-->
<!--        </div>-->
        <div class="left-nav" >
          <div class="titleNav">
            <div id="nav-body">
              <div class="bg_title">
                <p style="color: #fff;font-size:24px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap">{{ firstMenuName }}</p>
                <p style="color: #fff;font-size:14px;">List</p>
              </div>
              <div
                v-for="(item, i) in menuList"
                @click="toList(item.id, item.label,i)"
                :key="i"
                :class="activeMenuIndex==i?'activeBorder':'hoverBorder'"
                style="text-align: left;
                width:200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                margin-top: 3px;
                display: flex;
                align-items: center;
                justify-content: space-between"
                :title="item.label"
              >
                <p :class="activeMenuIndex==i?'activeP':''">{{ item.label }}</p>
                <img src="@/assets/list/active.png" alt="" style="width: 24px;height: 20px" v-if="activeMenuIndex!=i">
                <img src="@/assets/list/actived.png" alt="" style="width: 24px;height: 20px" v-else>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            width: calc(100% - 260px);
            margin-left: 24px;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start
          "
          class="rightContent"
        >
          <div style="position: absolute;top: -5%;left:5px;color: #fffffd;cursor:pointer;">
            <span @click="$router.push({ path: '/' })">首页</span> /
            <span>{{ firstMenuName }}</span> /
            <span v-if="menuName">{{ menuName }}</span>
          </div>
          <el-card
            v-for="(item, i) in contentList"
            @click.native="toDetail(item.id, item.title,i)"
            :key="i"
            :class="activeIndex==i?'activeCard':''"
            style="
              cursor: pointer;
              width: 32%;
              margin-right: 1%;
              margin-bottom: 10px;
              height: 220px;
            "
          >
            <div slot="header" class="clearfix">
              <img
                v-if="item.picUrl"
                :src="
                  item.picUrl ? '/mainsys/UserFiles/menupic/' + item.picUrl : ''
                "
                style="width: 100%; height: 170px"
              />
            </div>
            <div
              style="
                width: 100%;
                font-size: 18px;
                font-weight: 600;
                text-align: center;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 50px;
              "
            >
              {{ item.title }}
            </div>
          </el-card>

          <div style="width: 100%; text-align: center">
            <el-pagination
              style="text-align: center; margin-top: 10px"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page"
              :page-sizes="[10, 40, 50, 60]"
              :page-size="length"
              layout="total, sizes, jumper, prev, pager, next"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 底部快捷链接 -->
  <div class="bottomLink">
    <div style="
            margin: 0 auto;display: flex;
            align-items: center;
            justify-content: center;
            width: 1300px;
            padding: 0 5%;
            height: 60px;
">
      <div
        v-for="(item, index) in friendshipLink.res"
        :key="index"
        class="bottomLinkList"
        :style="{cursor:item.linkName == '中心服务'?'default':'pointer'}"
        @click="goLink(item)"
      >
        <div style="display:flex;align-items: center;">
          <img
            :src="'/mainsys/UserFiles/externalicon/' + item.linkImage"
            style="height: 18px;width: 18px;margin-right:12px;"
          />
          <div style="line-height: 20px;height: 20px;">
            {{ item.linkName }}
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- 底部版权信息 -->
  <div class="copyDiv">
    <div style="width: 1300px;margin: 0 auto;display: flex;
          justify-content: space-between;
          align-items: center;">
      <div class="copyDivLeft">
        <img
          :src="require('../assets/bottomLogo.png')"
          alt=""
          style="width:360px;height:50px;margin-bottom:16px"
        />
        <div class="copyDivLeftCon">建设单位：国防科技大学</div>
        <div class="copyDivLeftCon">支持单位：湖南强智科技发展有限公司</div>
        <div class="copyDivLeftCon">
          推荐使用: Chrome或Firefox等主流浏览器
        </div>
        <div class="copyDivLeftCon">
          Copyright © 1999- 2024 国防科技大学 版权所有
        </div>
        <div class="copyDivLeftCon">
          网站访问次数：{{websiteVisitsNum}} 次
        </div>
      </div>
      <div
        class="copyDivRight"
        style="text-align:center;width: 200px"
        v-if="friendshipLink.top && friendshipLink.top.length > 0"
      >
        <img
          :src="
              '/mainsys/UserFiles/externalicon/' +
                friendshipLink.top[0].linkImage
            "
          alt=""
          style="width:140px;height:140px;margin:0 auto;text-align: center"
        />
        <div style="font-size: 16px;color: #FAFAFA;margin-top: 16px">
          {{ friendshipLink.top[0].linkName }}
        </div>
      </div>
    </div>

  </div>
</div>
</template>

<script>
export default {
  name: "list",
  data() {
    return {
      fullscreenLoading: false,
      menuId: this.$route.params.menuId,
      firstMenuName: "",
      firstMenuId: "",
      menuList: [],
      contentList: [],
      total: 0, //总页数
      page: 1, //页码
      length: 10, //长度
      linkAddress: "", //链接地址
      activeMenuIndex: 0,
      activeIndex:0,
      menuName:"",
    };
  },
  watch:{
    $route(newVal,oldVal){
      if(newVal.params.menuId||newVal.params.menuIndex){
        this.menuId = newVal.params.menuId;
        this.activeMenuIndex=newVal.params.menuIndex
        this.getSecondList();
      }
    }
  },
  methods: {
    changeList(id) {
      this.menuId = id;
      this.getSecondList();
    },
    toList(menuId, label,index) {
      this.activeMenuIndex = index;
      this.menuId = menuId;
      this.getSecondList();
      // this.$router.push({
      //   path: "List:menuId",
      //   name: "List",
      //   params: { menuId: menuId, label: label },
      // });
    },
    // 每页条数变化
    handleSizeChange(val) {
      this.length = val;
      this.page = 1;
      this.getSecondList();
    },
    // 页码变化
    handleCurrentChange(val) {
      this.page = val;
      this.getSecondList();
    },
    getSecondList() {
      this.fullscreenLoading = true;
      let fd = new FormData();
      fd.append("page", this.page);
      fd.append("num", this.length);
      var choosedItem = {};
      // console.log("this.firstMenuName", this.firstMenuName);
      // let url = ""
//       if (sessionStorage.getItem("loginStatus")) {
//         if (sessionStorage.getItem("loginStatus") == "2") {
//           url = '/cmsapi/menus/'
//         }else{
// url = '/cmsapi/nomenus/'
//         }
//         }
      axios
        .post('/cmsapi/menus/' + this.menuId, fd, {
          //顶部友情链接
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
        })
        .then((response) => {
          var recData = response.data;
          if (recData.secondMenu.length > 0) {
            recData.secondMenu.forEach((item, index) => {
              if (item.id == this.menuId) {
                choosedItem = item;
                this.linkAddress = item.href ? item.href : "";
              }
            });
          }
          this.total = recData.total;
          this.firstMenuName = recData.firstMenuName;
          console.log("recData", recData)
          this.firstMenuId = recData.menuId;
          this.menuName = recData.menuName;
          this.contentList = recData.dataList;
          if (
            recData.menuName == "仪器预约记录" ||
            recData.menuName == "实验室预约记录" ||
            choosedItem.label == "使用记录" ||
            recData.menuName == "考勤记录" ||
            recData.menuName == "实验室信息" ||
            recData.menuName == "成绩查询" ||
            recData.menuName == "违规扣分处罚信息"
          ) {
            this.$router.push({
              path: "detail:contentId",
              name: "Detail",
              params: {
                contentId: this.contentList[0].id,
                label: recData.menuName,
              },
            });
          } else if (this.total == 1) {
            this.$router.push({
              path: "detail:contentId",
              name: "Detail",
              params: {
                contentId: this.contentList[0].id,
                label: this.contentList[0].title,
              },
            });
          }

          //如果只有一级菜单，就把一级菜单放上。
          if (recData.secondMenu.length == 0) {
            this.menuList = [
              {
                label: recData.firstMenuName,
                id: recData.menuId,
              },
            ];
          } else {
            //多条列表
            this.menuList = recData.secondMenu;
            if (
              choosedItem.label == "仪器预约记录" ||
              choosedItem.label == "实验室预约记录" ||
              choosedItem.label == "使用记录" ||
              choosedItem.label == "考勤记录" ||
              choosedItem.label == "成绩查询" ||
              recData.menuName == "实验室信息" ||
              recData.menuName == "违规扣分处罚信息"
            ) {
              this.$router.push({
                path: "detail:contentId",
                name: "Detail",
                params: {
                  contentId: this.contentList[0].id,
                  label: choosedItem.label,
                },
              });
            }
          }
          this.fullscreenLoading = false;
        })
        .catch((error) => {
          this.fullscreenLoading = false;
        });
    },
    toDetail(contentId, label,index) {
      this.activeIndex=index;
      this.$router.push({
        path: "detail:contentId",
        name: "Detail",
        params: { contentId: contentId, label: label },
      });
    },
  },
  mounted() {
    this.activeMenuIndex = this.$route.params.menuIndex?this.$route.params.menuIndex:0;
    this.$nextTick(() => {
      if (this.$route.params.menuId) {
        this.menuId = this.$route.params.menuId;
        this.activeMenuIndex=this.$route.params.menuIndex?this.$route.params.menuIndex:0;
        // this.activeMenuIndex = this.$route.params.menuIndex
        this.getSecondList();
      }
    });
  },
  beforeEacch(to, from, next) {
    if (this.$route.params.menuId) {
      this.menuId = this.$route.params.menuId;

      this.getSecondList();
    }
    next();
  },
  beforeRouteUpdate(to, from, next) {
    next();
    // if (this.$route.params.menuId) {
    this.menuId = this.$route.params.menuId;
    this.getSecondList();
    // }
  }
}


</script>
<style lang="less" scoped>
.contentBox{
  width: 1100px;
  display: flex;
  justify-content: space-between;
  min-height: 600px;
  .left-nav{
    width: 19%;
    position: relative;
    height: 380px;
    background-color: #f2f2f2;
    .bg_title{
      width: 209px;
      height: 90px;
      background: url("~@/assets/list/bg1.png") no-repeat;
      background-size: 100% 100%;
      padding: 15px 0 0 25px;
    }
  }
  .rightContent{
    width: 80%;
    height: 100%;
    padding-top: 20px;
    position: relative;
  }
}
.titleNav{
  position: absolute;
  top: -10%;
}
/deep/.el-card__header{
  padding: 0;
}
/deep/.el-card__body, .el-main{
  padding: 0;
}
.activeP{
  color: #002b9e;
}
.activeBorder{
  min-height: 49px;
  border-bottom: 1px solid rgba(223,227,232,1);
  padding-left: 15px;
  font-size:18px;
  font-weight:400;
  color:rgba(128,128,128,1);
  line-height: 49px;
  cursor: pointer;
  border-left: 4px solid #002b9e;
  color: #002b9e;
}
.hoverBorder{
  min-height: 49px;
  border-bottom: 1px solid rgba(223,227,232,1);
  padding-left: 15px;
  font-size:18px;
  font-weight:400;
  color:rgba(128,128,128,1);
  line-height: 49px;
  cursor: pointer;
}
.activeCard{
  border-bottom: 4px solid #002b9e;
}
/deep/.el-pagination__jump{
  margin-left: 6px;
}
//.hoverBorder :hover{
//  border-left: 4px solid #002b9e;
//  color: #002b9e;
//}
</style>
<style scoped>
.bottomLink {
  height: 60px;
  /* width: calc(100% - 520px); */
  background: #0d3b80;
  color: #fff;
  padding: 0 260px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottomLinkList {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 280px;
  position: relative;
}
.bottomLinkList:not(:last-child)::after {
  content: "";
  width: 1px;
  height: 24px;
  opacity: 0.2;
  background-color: #fff;
  position: absolute;
  right: 0;
}
.linkDivider >>> .el-divider--vertical {
  height: 24px !important;
  background-color: #3f6bae !important;
  width: 1.5px !important;
  margin: 0 30px 36px 30px !important;
}
.copyDiv {
  height: 300px;
  /* width: calc(100% - 520px); */
  padding: 45px 260px;
  background: url("../assets/bottomBg.jpg") no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.copyDivLeftCon {
  opacity: 0.8;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  color: #ffffff;
  letter-spacing: 0;
  margin-top: 16px;
}
</style>
